import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchNominationDetails = (payload) => {
  return {
    type: actionTypes.FETCH_NOMINATION_DETAILS,
    formData: payload,
  };
};
// bi started
export const editNominationDetailsStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_NOMINATION_DETAILS_START,
  };
};

export const editNominationDetailsSuccess = (formData, succMsg, res) => {
  return {
    type: actionTypes.FETCH_NOMINATION_DETAILS_SUCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
    response: res,
  };
};

// export const fetchNominationDetailsSuccess = (payload, apiPath,res) => {
//   return async (dispatch) => {
//     dispatch(editNominationDetailsStarted());
//     axiosRequest.put(apiPath, payload).then((res)=>{
//       //console.log(res?.NominationDetails)
//         dispatch(fetchNominationDetails(res?.NominationDetails));
//     });
//   };
// };

export const fetchNominationDetailsSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editNominationDetailsStarted());
    try {
      const res = await axiosRequest.put(apiPath, payload);
      dispatch(fetchNominationDetails(res?.NominationDetails));
      return res; // Return the response
    } catch (err) {
      // Handle errors here if needed
      console.error("Error in fetchNominationDetailsSuccess:", err);
      throw err; // Re-throw the error to propagate it to the caller
    }
  };
};

export const editNominationDetailsFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_NOMINATION_DETAILS_FAIL,
    error: errMsg,
  };
};
